export type VatInformation = {
  isVat: boolean;
  isViesVerified: boolean;
  viesResponse: {
    address: string;
    countryCode: string;
    name: string;
    requestDate: Date;
    valid: boolean;
    vatNumber: string;
  };
};
